/**
 *  注销相关内容
 */

// 首页
Vue.component(
    'log-off',
    resolve => require(["../../components/logOff/Index"], resolve),
);

// 恢复账号/查询
Vue.component(
    'log-off-recover',
    resolve => require(["../../components/logOff/Recover"], resolve)
);

// 账号查询
Vue.component(
    'log-off-progress',
    resolve => require(["../../components/logOff/Progress"], resolve)
);

// 申请注销
Vue.component(
    'log-off-apply',
    resolve => require(["../../components/logOff/Apply"], resolve),
);

// 注销协议
Vue.component(
    'log-off-agreement',
    resolve => require(["../../components/logOff/Agreement"], resolve),
);



// WEBPACK FOOTER //
// ./resources/js/signCom/module/logOff.js